import { productInformationStyles as styles } from "@solveindustrial/Overrides/Widgets/ProductList/ProductListProductInformation";
import { css } from "styled-components";

styles.container = {
    ...styles.container,
    gap: 0,
    css: css`
        ${styles.container?.css}
        height: 100%;
    `,
    offsetCss: css`
        ${styles.container?.offsetCss}
        flex-direction: column;
        justify-content: flex-start;
        gap: 4px;
        height: 100%;
        flex-wrap: nowrap !important;
    `,
};

styles.logInButtonGridItem = {
    width: 12,
    css: css`
        ${styles.logInButtonGridItem?.css}
        flex-basis: auto;
        margin: auto 0 0 !important;
    `,
};

styles.brandGridItem = {
    ...styles.brandGridItem,
    css: css`
        ${styles.brandGridItem?.css};
        flex-basis: auto;
    `,
};
styles.descriptionGridItem = {
    ...styles.descriptionGridItem,
    css: css`
        ${styles.descriptionGridItem?.css};
        flex-basis: auto;
    `,
};
styles.partNumbersGridItem = {
    ...styles.partNumbersGridItem,
    css: css`
        ${styles.partNumbersGridItem?.css};
        flex-basis: auto;
    `,
};
styles.swatchGridItem = {
    ...styles.swatchGridItem,
    css: css`
        ${styles.swatchGridItem?.css};
        flex-basis: auto;
    `,
};
styles.imageBadgeGridItem = {
    ...styles.imageBadgeGridItem,
    css: css`
        ${styles.imageBadgeGridItem?.css};
        flex-basis: auto;
    `,
};
styles.textBadgeGridItem = {
    ...styles.textBadgeGridItem,
    css: css`
        ${styles.textBadgeGridItem?.css};
        flex-basis: auto;
    `,
};
styles.availabilityGridItem = {
    ...styles.availabilityGridItem,
    css: css`
        ${styles.availabilityGridItem?.css};
        flex-basis: auto;
        margin: auto 0 0 !important;
    `,
};
styles.attributesGridItem = {
    ...styles.attributesGridItem,
    css: css`
        ${styles.attributesGridItem?.css};
        flex-basis: auto;
    `,
};
styles.searchScoreDataGridItem = {
    ...styles.searchScoreDataGridItem,
    css: css`
        ${styles.searchScoreDataGridItem?.css};
        flex-basis: auto;
    `,
};